<template>
    <el-dialog
        class="shipped"
        :visible.sync="shippedVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="800px"
        title="Shipped"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="shippedForm"
                :model="shippedForm"
                :rules="rules"
                label-width="120px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="Platform"
                            prop="platform_id"
                            size="small"
                        >
                            <el-select
                                v-model="shippedForm.platform_id"
                                placeholder="Please Select"
                                style="width:100%"
                            >
                                <el-option
                                    v-for="item in platformList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Order" prop="order_sn_txt" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="shippedForm.order_sn_txt"
                                placeholder="Please enter the order number,replace the batch with a new line"
                                type="textarea"
                                :autosize="{ minRows: 10, maxRows: 20 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div style="margin-left:120px;color:rgb(252, 133, 64)">Note: Only orders with a status of  Shipped and Shipped as Fail/No support submission.</div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="closeDialog">Close</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapState, mapActions } from "vuex";
const selectPlaceholder = "Please select ";
const inputPlaceholder = "Please input ";
export default {
    computed: {
        ...mapState({
            menu_id: (state) => state.menu.menu_id,
        }),
    },
    data() {
        return {
            shippedForm: {
                platform_id: "",
                order_sn_txt: ""
            },
            rules: {
                platform_id: [
                    {
                        required: true,
                        message: selectPlaceholder,
                    },
                ],
                order_sn_txt: [
                    {
                        required: true,
                        message: inputPlaceholder,
                    },
                ]
            },
            platformList: [],
        };
    },
    methods: {
        platformSelect() {
            cmofferApi.platformSelect({}, "get").then((res) => {
                if (res) {
                    this.platformList = res.data;
                }
            });
        },
        closeDialog() {
            this.shippedForm = {
                platform_id: "",
                order_sn_txt: ""
            };
            this.$refs["shippedForm"].clearValidate();
            this.$refs["shippedForm"].resetFields();
            this.$emit("update:shippedVisible", false);
        },
        save() {
            this.$refs["shippedForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .orderPassBack(
                            {
                                ...this.shippedForm,
                            },
                            "post"
                        )
                        .then((res) => {
                            this.loading = false;
                            if(res.error.length > 0){
                                this.$message.warning({
                                    dangerouslyUseHTMLString: true,
                                    message: '<div style="line-height:25px">Submission failed<br/>'+res.error+'</div>',
                                    duration: 6000,
                                    showClose: true
                                });
                            }else{
                                this.$message.success({
                                    dangerouslyUseHTMLString: true,
                                    message: '<div>Successfully submitted<br/><br/>please refresh the data in 5 minutes to view the results.</div>',
                                    duration: 5000,
                                    showClose: true
                                });
                                this.closeDialog();
                                this.$parent[this.funcName]();
                            }
                            
                        });
                }
            });
        },

    },
    props: {
        shippedVisible: Boolean,
        selectPltOrderSn: Array,
        funcName: String,
    },
    watch: {
        shippedVisible() {
            if (this.shippedVisible) {
                this.platformSelect();
                this.shippedForm.order_sn_txt = this.selectPltOrderSn.join("\n");
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.shipped {
    .container {
        ::v-deep .table {
            .el-form-item {
                margin-bottom: 0px;
            }
            .el-input-group__prepend {
                padding: 0 10px;
                /* & + .el-input__inner {
                    padding-right: 10px;
                } */
            }
            .el-form-item__content .el-input{
                width:100%
            }
        }
    }

}

</style>